<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-album-fill`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42 4a2 2 0 011.995 1.85L44 6v36a2 2 0 01-1.85 1.995L42 44H6a2 2 0 01-1.995-1.85L4 42V6a2 2 0 011.85-1.995L6 4h36zm-6.234 16.366a.8.8 0 01.234.565V35.4a.6.6 0 01-.6.6H20.449a.6.6 0 01-.162-.022l-8.556-.022a.6.6 0 01-.422-1.024l8.265-8.266a.8.8 0 011.131 0l3.814 3.814 10.115-10.114a.8.8 0 011.132 0zM18 12v6h-6v-6h6z"/></svg>
</template>
<script>

export default {
  name: 'IconAlbumFill',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
